export const TAG_COLORS = ['#e1e7ec', '#e3f0fc', '#fff3e1', '#e9f7e9', '#fce4e9'];